import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDE8rgl4XhILhQwqU0qJw1cJEun2tmDl4E',
  authDomain: 'core-crm-80252.firebaseapp.com',
  databaseURL: 'https://core-crm-80252.firebaseio.com',
  projectId: 'core-crm-80252',
  storageBucket: 'core-crm-80252.appspot.com',
  messagingSenderId: '368328490882',
  appId: '1:368328490882:web:3c7c24edbab40facaf599b',
  measurementId: 'G-C9KFMPLN61',
};

firebase.initializeApp(firebaseConfig);

const doppelganger = firebase.initializeApp(firebaseConfig, 'secondary');
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

const usersCollection = db.collection('users');
const companiesCollection = db.collection('companies');
const teamsCollection = db.collection('teams');
const clientsCollection = db.collection('clients');
const projectsCollection = db.collection('projects');
const boardsCollection = db.collection('boards');
const tasksCollection = db.collection('tasks');
const commentsCollection = db.collection('comments');
const teamUsersCollection = db.collection('teams_users');

export {
  db,
  auth,
  storage,
  doppelganger,
  usersCollection,
  companiesCollection,
  projectsCollection,
  teamsCollection,
  clientsCollection,
  boardsCollection,
  tasksCollection,
  commentsCollection,
  teamUsersCollection,
};
